<template>
    <div
        class="installation"
        :class="{
            modeHeat: modeHeat,
            'installation--show ': show,
            'd-none': hidden,
            'installation--outService': outService,
        }"
        @click.stop="openClose('box')"
    >
        <div class="installation__name" :data-icoTarget="type">
            {{ name }}
            <div class="icoButton__options">
                <div
                    class="icoButton icoButton__config"
                    data-icoTarget="setUp"
                    @click.stop="$emit('actionClick')"
                ></div>
                <div class="icoButton icoButton__downUp" data-icoTarget="down" @click.stop="openClose('button')"></div>
            </div>
        </div>

        <slot name="installationModal"></slot>

        <slot name="installationProperties"></slot>

        <div v-if="show" class="installation__outService" style="z-index: initial;">
            <i>{{ $dicc.outService }}</i>
        </div>

        <slot name="device" :outService="true"></slot>
    </div>
</template>

<script>
    import ui_Ico from './ui-Ico.vue';

    export default {
        components: { ui_Ico },
        name: 'ui-Installation',
        props: {
            name: {
                type: String,
                default: 'Zone installation',
            },
            type: {
                type: String,
                default: 'installation-zones',
            },
            modeHeat: {
                type: Boolean,
                default: false,
            },
            hidden: {
                type: Boolean,
                default: false,
            },
            show: {
                type: Boolean,
                default: false,
            },
            outService: {
                // true: instalación fuera de servicio
                type: Boolean,
                default: false,
            },
        },
        methods: {
            openClose: function(element) {
                if ((element == 'box' && !this.show) || element == 'button') this.$emit('update:show', !this.show);
            },
        },
        computed: {},
    };
</script>
